module.exports = __webpack_public_path__ + "static/notebook-d9a3a65f37b14c24eb0b2f7adfe1a364.png";